import './TimelinePresets.scss';

const TimelinePresets = ({preset, years, onChange}) => (
    <div className="timeline-presets">
        <button
            className={`timeline-preset-btn${preset === 'last-year' ? ' timeline-preset-btn--active' : ''}`}
            onClick={() => onChange('last-year')}
        >
            Last Year
        </button>
        <select
            className={`timeline-year-select${preset.startsWith('year-') ? ' timeline-year-select--active' : ''}`}
            value={preset.startsWith('year-') ? preset : ''}
            onChange={e => e.target.value && onChange(e.target.value)}
        >
            {!preset.startsWith('year-') && <option value="">Year</option>}
            {years.map(y => (
                <option key={y} value={`year-${y}`}>{y}</option>
            ))}
        </select>
        <button
            className={`timeline-preset-btn${preset === 'all-time' ? ' timeline-preset-btn--active' : ''}`}
            onClick={() => onChange('all-time')}
        >
            All time
        </button>
    </div>
);

export default TimelinePresets;